import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie/es6';
import { Svg, useEcom, config } from '@thisisdevelopment/akzonobel-core';
import { CartStyled, Badge } from './styled';

type PropTypes = {
  cartUrl?: string;
};

function Cart({ cartUrl = config.cartUrl }: PropTypes) {
  const { cart, updateCart } = useEcom();
  const [changing, setChanging]: [boolean, Function] = useState(true);
  const cookies = new Cookies();

  useEffect(() => {
    if (cookies.get('orderNumber') && cookies.get('orderToken') && cookies.get('hasOrder')) {
      updateCart();
    }
  }, [updateCart]);

  useEffect(() => {
    if (cart && cart.item_count > 0) {
      setChanging(true);
      setTimeout(() => setChanging(false), 500);
    }
  }, [cart, setChanging]);

  return (
    <CartStyled href={cartUrl}>
      <Svg.Cart />
      {cart && cart.item_count > 0 && <Badge changing={changing}>{cart?.item_count}</Badge>}
    </CartStyled>
  );
}

export default Cart;
